import { render, staticRenderFns } from "./scanpackNew.vue?vue&type=template&id=c4689ba2&scoped=true&"
import script from "./scanpackNew.vue?vue&type=script&lang=js&"
export * from "./scanpackNew.vue?vue&type=script&lang=js&"
import style0 from "./scanpackNew.vue?vue&type=style&index=0&id=c4689ba2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4689ba2",
  null
  
)

export default component.exports